$(document).on('click', '.share-tutorial-btn', function(e) {
    e.preventDefault();
    let url = $(this).data('url');
    let id = $(this).data('id');
    $('#shareTutorialLink').val(url);
    $('#shareTutorialModal').attr('data-tutorial-id', id);
    $('#copyLinkToPage').attr('data-link', url);
    if (typeof $('#shareTutorialEmail').tagsinput === 'function') {
        $('#shareTutorialEmail').tagsinput('removeAll');
    }
    $('#shareTutorialModal').modal('show');
});

$(document).on('click', '#sendTutorialEmail', function() {
    let id = $('#shareTutorialModal').data('tutorial-id');
    let emails = $('#shareTutorialEmail').val();
    if (!emails) {
        show_ajax_error('Please enter at least one email address.');
        return;
    }

    $(this).prop('disabled', true).text('Sending...');

    $.ajax({
        url: `/knowledge_hub/tutorials/${id}/share`,
        method: 'POST',
        data: { emails: emails },
        success: function(response) {
            show_ajax_notice(response.message);
            $('#shareTutorialModal').modal('hide');
        },
        error: function(xhr) {
            show_ajax_error(xhr.responseJSON.error || 'Something went wrong.');
        },
        complete: function() {
            $('#sendTutorialEmail').prop('disabled', false).text('Send Email');
        }
    });
});
